export default __webpack_public_path__ + "images/schedule_or_start_design.360c44f2dc977e271ae34af16111fa58.png";